import './loader.scss'
import loader from '../../assets/images/loader.gif';

export default function Loader() {
  return (
    <div className="loading-overlay">
      <img src={loader} alt="loader" />
    </div>
  );
}